import { Converter } from '../types/converter';

export const flowConverter: Converter = {
  id: 'flow',
  name: 'Flow Converter',
  icon: 'ArrowRight',
  categories: ['engineering', 'fluids'],
  units: [
    // Base SI unit and derivatives
    { name: 'Cubic meter/second', symbol: 'm³/s', factor: 1 },
    { name: 'Cubic meter/day', symbol: 'm³/d', factor: 1.1574074074074074e-5 },
    { name: 'Cubic meter/hour', symbol: 'm³/h', factor: 0.0002777777777777778 },
    { name: 'Cubic meter/minute', symbol: 'm³/min', factor: 0.016666666666666666 },
    
    // Cubic centimeter units
    { name: 'Cubic centimeter/day', symbol: 'cm³/d', factor: 1.1574074074074074e-11 },
    { name: 'Cubic centimeter/hour', symbol: 'cm³/h', factor: 2.777777777777778e-10 },
    { name: 'Cubic centimeter/minute', symbol: 'cm³/min', factor: 1.6666666666666667e-8 },
    { name: 'Cubic centimeter/second', symbol: 'cm³/s', factor: 1e-6 },
    
    // Liter units
    { name: 'Liter/day', symbol: 'L/d', factor: 1.1574074074074074e-8 },
    { name: 'Liter/hour', symbol: 'L/h', factor: 2.777777777777778e-7 },
    { name: 'Liter/minute', symbol: 'L/min', factor: 1.6666666666666667e-5 },
    { name: 'Liter/second', symbol: 'L/s', factor: 0.001 },
    
    // Milliliter units
    { name: 'Milliliter/day', symbol: 'mL/d', factor: 1.1574074074074074e-11 },
    { name: 'Milliliter/hour', symbol: 'mL/h', factor: 2.777777777777778e-10 },
    { name: 'Milliliter/minute', symbol: 'mL/min', factor: 1.6666666666666667e-8 },
    { name: 'Milliliter/second', symbol: 'mL/s', factor: 1e-6 },
    
    // US Gallon units
    { name: 'Gallon (US)/day', symbol: 'gal (US)/d', factor: 4.381264e-8 },
    { name: 'Gallon (US)/hour', symbol: 'gal (US)/h', factor: 1.0515034e-6 },
    { name: 'Gallon (US)/minute', symbol: 'gal (US)/min', factor: 6.309020e-5 },
    { name: 'Gallon (US)/second', symbol: 'gal (US)/s', factor: 0.003785412 },
    
    // UK Gallon units
    { name: 'Gallon (UK)/day', symbol: 'gal (UK)/d', factor: 5.262404e-8 },
    { name: 'Gallon (UK)/hour', symbol: 'gal (UK)/h', factor: 1.2629769e-6 },
    { name: 'Gallon (UK)/minute', symbol: 'gal (UK)/min', factor: 7.577862e-5 },
    { name: 'Gallon (UK)/second', symbol: 'gal (UK)/s', factor: 0.00454609 },
    
    // Barrel units
    { name: 'Kilobarrel (US)/day', symbol: 'kbbl (US)/d', factor: 0.001840131 },
    { name: 'Barrel (US)/day', symbol: 'bbl (US)/d', factor: 1.840131e-6 },
    { name: 'Barrel (US)/hour', symbol: 'bbl (US)/h', factor: 4.416314e-5 },
    { name: 'Barrel (US)/minute', symbol: 'bbl (US)/min', factor: 0.002649788 },
    { name: 'Barrel (US)/second', symbol: 'bbl (US)/s', factor: 0.158987294928 },
    
    // Acre-foot units
    { name: 'Acre-foot/year', symbol: 'ac*ft/y', factor: 3.911011e-5 },
    { name: 'Acre-foot/day', symbol: 'ac*ft/d', factor: 0.014276712 },
    { name: 'Acre-foot/hour', symbol: 'ac*ft/h', factor: 0.342641088 },
    
    // Hundred cubic foot units
    { name: 'Hundred-cubic foot/day', symbol: 'hcf/d', factor: 3.277413e-7 },
    { name: 'Hundred-cubic foot/hour', symbol: 'hcf/h', factor: 7.865791e-6 },
    { name: 'Hundred-cubic foot/minute', symbol: 'hcf/min', factor: 4.719475e-4 },
    
    // Ounce units
    { name: 'Ounce/hour', symbol: 'oz/h', factor: 8.226738e-9 },
    { name: 'Ounce/minute', symbol: 'oz/min', factor: 4.936043e-7 },
    { name: 'Ounce/second', symbol: 'oz/s', factor: 2.957626e-5 },
    { name: 'Ounce (UK)/hour', symbol: 'oz (UK)/h', factor: 7.8906e-9 },
    { name: 'Ounce (UK)/minute', symbol: 'oz (UK)/min', factor: 4.73436e-7 },
    { name: 'Ounce (UK)/second', symbol: 'oz (UK)/s', factor: 2.84062e-5 },
    
    // Cubic yard units
    { name: 'Cubic yard/hour', symbol: 'yd³/h', factor: 0.000212376 },
    { name: 'Cubic yard/minute', symbol: 'yd³/min', factor: 0.012742584 },
    { name: 'Cubic yard/second', symbol: 'yd³/s', factor: 0.764555084 },
    
    // Cubic foot units
    { name: 'Cubic foot/hour', symbol: 'ft³/h', factor: 7.865791e-6 },
    { name: 'Cubic foot/minute', symbol: 'ft³/min', factor: 0.000471947 },
    { name: 'Cubic foot/second', symbol: 'ft³/s', factor: 0.028316847 },
    
    // Cubic inch units
    { name: 'Cubic inch/hour', symbol: 'in³/h', factor: 4.551927e-9 },
    { name: 'Cubic inch/minute', symbol: 'in³/min', factor: 2.731156e-7 },
    { name: 'Cubic inch/second', symbol: 'in³/s', factor: 1.638694e-5 },
    
    // Mass flow units (Gasoline at 15.5°C)
    { name: 'Pound/second (Gasoline at 15.5°C)', symbol: 'lb/s', factor: 0.000453592 },
    { name: 'Pound/minute (Gasoline at 15.5°C)', symbol: 'lb/min', factor: 7.559867e-6 },
    { name: 'Pound/hour (Gasoline at 15.5°C)', symbol: 'lb/h', factor: 1.259978e-7 },
    { name: 'Pound/day (Gasoline at 15.5°C)', symbol: 'lb/d', factor: 5.249908e-9 },
    { name: 'Kilogram/second (Gasoline at 15.5°C)', symbol: 'kg/s', factor: 0.001 },
    { name: 'Kilogram/minute (Gasoline at 15.5°C)', symbol: 'kg/min', factor: 1.666667e-5 },
    { name: 'Kilogram/hour (Gasoline at 15.5°C)', symbol: 'kg/h', factor: 2.777778e-7 },
    { name: 'Kilogram/day (Gasoline at 15.5°C)', symbol: 'kg/d', factor: 1.157407e-8 }
  ]
};
